import { initials, markColor } from '@/lib/cobalt-helpers';
import { cn } from '@/lib/utils';

interface Props {
  /** Full person name; used to derive initials + stable color. */
  name: string | null | undefined;
  size?: number;
  className?: string;
}

/** Circular initials avatar. Stable color per name. */
export function UserAvatar({ name, size = 24, className }: Props) {
  const rgb = markColor(name);
  const label = initials(name);
  return (
    <span
      aria-hidden="true"
      className={cn('inline-flex shrink-0 items-center justify-center rounded-full font-semibold leading-none', className)}
      style={{
        width: size,
        height: size,
        background: `rgb(${rgb} / 0.18)`,
        color:      `color-mix(in srgb, rgb(${rgb}), white var(--mark-lift))`, // lifted for dark (index.css)
        fontSize:   Math.round(size * 0.42),
        letterSpacing: '0.02em',
      }}
    >
      {label}
    </span>
  );
}
